<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text mgr_15">
					Code Type
				</em>
				<span class="int_type mgr_15">
					<select v-model="code_type" class="tbl_select sm_int" @change="onFilterChange()">
						<option v-for="codeType in filteredCodeTypes" v-bind:value="codeType.value" v-bind:key="codeType.value">{{ codeType.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="active_yn" class="tbl_select sm_int" @change="onFilterChange()">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>

				<label for="include_deleted" style="margin-right:15px;"> <input type="checkbox" id="include_deleted" v-model="include_deleted" @change="onFilterChange()" />Include Deleted</label>

				<span class="int_type mgr_5">
					<input type="text" v-model.trim="filterKeyword" ref="code" class="tbl_int sm_int" placeholder="Filter Code" @focus="$event.target.select()" />
				</span>
				<label for="startsWith" style="margin-right:5px;"> <input type="checkbox" id="startsWith" v-model="startsWith" />Starts With</label>

				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl" style="height:780px;">
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<!-- #3252 : beautyplus 는 Order No 대신 맨 앞 No.(행 번호)를 보여준다.
									     #3126 재정렬(드래그·헤더 정렬·Save Order)은 그대로 두고 숫자 컬럼·입력만 숨긴다. -->
									<th v-if="isBeautyplus" style="text-align:center;width:40px;"><div class="th-text">No.</div></th>
									<th style="text-align:center;width:28px;"></th>
									<th style="text-align:center;width:120px;" :class="{ sortable: reorderEnabled }" @click="sortBy('code')">
										<div class="th-text">Code{{ sortArrow('code') }}</div>
									</th>
									<th style="text-align:center;width:30px;"></th>
									<th style="text-align:center;width:200px;" :class="{ sortable: reorderEnabled }" @click="sortBy('name')">
										<div class="th-text">Name{{ sortArrow('name') }}</div>
									</th>
									<th style="text-align:center;">
										<div class="th-text">{{ code_type == 'PT' ? 'Due Days' : code_type == 'PLT' ? 'Weight' : 'Description' }}</div>
									</th>
									<th style="text-align:center;width:100px;"><div class="th-text">Alt. Code</div></th>
									<th v-if="!hideOrderNo" style="text-align:center;width:80px;">
										<div class="th-text">
											<div class="th-text">{{ code_type == 'WL' ? 'P. Order' : 'Order No' }}</div>
										</div>
									</th>
									<th style="text-align:center;width:60px;"><div class="th-text">Active</div></th>
								</tr>
							</thead>

							<tbody>
								<tr
									v-for="(code, index) in filteredCodes"
									v-bind:key="code.code"
									v-bind:class="{ on: code.code == selectedCode.code, 'drag-over': index === drag_over }"
									@click="selectRow(code)"
									@dragover.prevent
									@drop="onDrop(index)"
									@dragenter.prevent="onDragEnter(index)"
								>
									<td v-if="isBeautyplus" style="text-align:right;">{{ index + 1 }}</td>
									<td v-if="reorderEnabled" draggable="true" @dragstart="onDragStart(index, $event)" @dragend="onDragEnd" @click.stop @mousedown.stop class="drag-handle">☰</td>
									<td v-else></td>
									<td>{{ code.code }}</td>
									<td><img v-img v-if="code.image_file_name" :src="getImageUrl(code)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:20px;height:auto;width:auto;" /></td>
									<td>{{ code.name }}</td>
									<td>{{ code.description }}</td>
									<td>{{ code.alt_code }}</td>
									<td v-if="!hideOrderNo" style="text-align:right;">{{ code.order_no }}</td>
									<td style="text-align:center;">
										<span v-if="code.del_yn == 'Y'">Deleted</span>
										<span v-else>{{ code.active_yn }}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div style="text-align:right;padding-top:5px; padding-right:10px;">Total Count : {{ codes.length | commaSeparated }}</div>

				<div v-if="modifiable" class="view_bottom_bt">
					<span v-if="!user.image_mgmt_only && !reorderEnabled && mode != 'add'" class="reorder-hint">* To reorder, set Status to "All Status"</span>
					<span v-if="!user.image_mgmt_only && reorderEnabled && !order_dirty" class="reorder-help">* Click Code/Name header to sort, or drag ☰ to reorder, then Save Order.</span>
					<span v-if="order_dirty" class="reorder-dirty">* Unsaved order changes</span>
					<a href="javascript:;" v-if="!user.image_mgmt_only && reorderEnabled" :class="!order_dirty ? 'disable_bt' : 'search_bt'" @click="saveOrder()">Save Order</a>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<a href="javascript:;" v-if="!user.image_mgmt_only" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_tbl">
				<h4 class="inner_h5">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:100px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<!-- <#if Session.session_user.admin_yn == 'Y'> -->
						<tr>
							<th>Code</th>
							<td>
								<input type="text" v-model.trim="code.code" maxlength="64" ref="code" class="tbl_int lm_int" v-bind:disabled="mode == 'detail'" />
								<button v-if="mode == 'add'" v-bind:disabled="!code.code" class="gray_bt" @click="checkDup()">Check Dup.</button>
								<span v-if="mode == 'detail'">
									<span v-if="code.crt_dt">Created: {{ code.crt_dt | moment('MM-DD-YYYY') }} {{ code.crt_user }}</span
									><span v-if="code.upd_dt">, Updated: {{ code.upd_dt | moment('MM-DD-YYYY') }} {{ code.upd_user }}</span></span
								>
							</td>
						</tr>

						<tr>
							<th>Name</th>
							<td><input type="text" v-model.trim="code.name" class="tbl_int full_int" /></td>
						</tr>
						<tr>
							<th>{{ descriptionTitle }}</th>
							<td><input type="text" v-model.trim="code.description" class="tbl_int full_int" :placeholder="descriptionTitle" /></td>
						</tr>
						<tr>
							<th>Alternative Code</th>
							<td><input type="text" v-model.trim="code.alt_code" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>{{ remarkTitle }}</th>
							<td><input type="text" v-model.trim="code.remark" class="tbl_int sm_int" :placeholder="code_type === 'WL' ? 'City State ZipCode' : ''" /></td>
						</tr>
						<!-- #3252 : beautyplus 는 Order No 입력을 쓰지 않는다(WL 의 P. Order 는 피킹 기능이라 예외).
						     숨겨도 로드된 기존 값은 code 객체에 남아 update 때 그대로 전송된다(값 보존). -->
						<tr v-if="!hideOrderNo">
							<th>{{ code_type == 'WL' ? 'Pick ' : '' }}Order No</th>
							<td><input type="number" v-model.trim="code.order_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr v-if="code.del_yn != 'Y'">
							<th>
								<img v-img v-if="code.image_file_name" :src="getImageUrl(code)" alt="File Not Found" style="cursor: zoom-in;max-height:70px;max-width:70px;height:auto;width:auto;" />
								<span v-if="!code.image_file_name">Picture</span>
							</th>
							<td>
								<button v-if="modifiable" :disabled="mode == 'add' || !code.code" class="btn" @click="uploadFile()">{{ !code.image_file_name ? 'Upload' : 'Replace' }} File</button>
								<input v-show="false" type="file" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />
								&nbsp;
								<button v-if="modifiable" :disabled="!code.image_file_name" class="btn" style="margin-top:10px;" @click="clear()">Clear Picture</button>
							</td>
						</tr>
						<tr>
							<th></th>
							<td v-if="code.del_yn != 'Y'">
								<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="code.active_yn" true-value="Y" false-value="N" />Active</label>
							</td>
						</tr>
						<CodeOtherBool :code="code" :code_type="code_type" />
					</tbody>
				</table>

				<div v-if="modifiable" class="view_bottom_bt" style="padding-top:15px;">
					<a v-if="!user.image_mgmt_only && code_type === 'COL' && code.del_yn != 'Y'" href="javascript:void(0);" class="gray_bt mgr_5" @click="updateAllWhColorCode()">All Update Color 2nd Code</a>
					<a v-if="!user.image_mgmt_only && code.del_yn != 'Y'" href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
					<a v-if="!user.image_mgmt_only && code.del_yn != 'Y' && false" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a>
				</div>
			</div>
		</div>
		<!-- 
			<div class="contents_box">
				<CodeList />
				<CodeDetail />
			</div>
		</div> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectCodeList, apiCheckCodeExists, apiInsertCode, apiUpdateCode, apiDeleteCode, apiInsertPicture, apiDeletePicture, apiUpdateOrderList } from '@/api/basicinfo/code.js';
import { apiUploadFile } from '@/api/util.js';
import _ from 'lodash';
import '@/assets/css/table_box.css';
import CodeOtherBool from '@/views/basicinformation/CodeOtherBool';
import { apiAllItemClassesWHColorCode } from '@/api/item/class';

export default {
	data: function() {
		return {
			backUri: '/',
			code_type: null,
			active_yn: 'Y',
			other_bool: false,
			mode: null,

			include_deleted: false,
			//codeTypes: ['Remarks', 'Department', 'Truck'],

			codes: [],
			selectedCode: {},
			// selectedCode: {
			// 	code: null,
			// 	name: null,
			// },

			code: {},

			filterKeyword: null,
			startsWith: false,

			order_dirty: false,
			sort_col: null,
			sort_dir: null,
			drag_from: null,
			drag_over: null,
			applied_filter: { code_type: null, active_yn: null, include_deleted: null },

			//selectedCode: null,
		};
	},
	props: ['headers'],
	watch: {
		// codes: function(newValue, oldValue) {
		// 	if (oldValue) console.log('data changed from ', oldValue, 'to ', newValue);
		// },
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		// #3252 : 목록의 No.·Order No 표시만 가르는 회사 판정.
		isBeautyplus() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus';
		},
		// #3252 : beautyplus 는 Order No 를 숨긴다. 단 WL 의 P. Order 는 라벨만 다른 것이
		// 아니라 피킹 순서 기능(PickOrder·InvoiceService)이 실사용하므로 유지한다.
		hideOrderNo() {
			return this.isBeautyplus && this.code_type !== 'WL';
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.code_type || !this.code.code || !this.code.code_type) return false;
			else return true;
		},
		isDeletable() {
			//if (this.mode == 'detail' && this.codes.length > 0 && this.code) return true;
			if (this.mode == 'detail' && this.selectedCode) return true;
			else return false;
		},
		filteredCodeTypes() {
			var result = {};
			if (this.user.admin_yn == 'Y' || this.visible) result = _.orderBy(this.$codeTypes, 'text', 'asc');
			else {
				var codeTypes = [];

				if (this.user.color_code_mgmt) codeTypes.push(this.$codeTypes.filter(ct => ct.value == 'COL')[0]);
				if (this.user.icc_code_mgmt) codeTypes.push(this.$codeTypes.filter(ct => ct.value == 'ICC')[0]);

				result = _.orderBy(codeTypes, 'text', 'asc');
			}
			// result = _.orderBy(
			// 	this.$codeTypes.filter(ct => ct.value == 'COL'),
			// 	'text',
			// 	'asc',
			// );

			if (this.headers.class == 'Style') {
				result.forEach(r => {
					r.text = r.text.replace('Class', 'Style');
				});
			}

			return result;
		},
		filteredCodes() {
			if (!this.filterKeyword) return this.codes;
			else {
				if (this.startsWith) return this.codes.filter(c => c.code.toUpperCase().startsWith(this.filterKeyword.toUpperCase()));
				else return this.codes.filter(c => c.code.toUpperCase().indexOf(this.filterKeyword.toUpperCase()) >= 0);
			}
		},
		visible() {
			if (this.user.admin_yn == 'Y') return true;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				//console.log(menus[i]);
				if (menus[i].path == this.$router.history.current.path && menus[i].view_yn == 'Y' && !menus[i].hide) return true;
			}
			return false;
		},
		modifiable() {
			if (this.user.admin_yn == 'Y' || this.user.color_code_mgmt || this.user.icc_code_mgmt) return true;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},

		reorderEnabled() {
			return this.modifiable && !this.user.image_mgmt_only && !this.filterKeyword && this.active_yn == 'A' && !this.include_deleted && this.mode != 'add';
		},
		descriptionTitle() {
			let title = 'Description';
			if (this.code_type === 'PT') title = 'Due Days';
			else if (this.code_type === 'PLT') title = 'Weight';
			else if (this.code_type === 'WL') title = 'Address Detail';
			return title;
		},

		remarkTitle() {
			let title = 'Remark';
			if (this.code_type === 'WL') title = 'Location Info';
			return title;
		},
	},
	components: {
		CodeOtherBool,
	},
	methods: {
		sortBy(col) {
			if (!this.reorderEnabled || this.codes.length == 0) return;
			const dir = this.sort_col === col && this.sort_dir === 'asc' ? 'desc' : 'asc';
			const factor = dir === 'asc' ? 1 : -1;
			this.codes.sort((a, b) => factor * String(a[col] || '').localeCompare(String(b[col] || ''), undefined, { sensitivity: 'base', numeric: true }));
			this.codes.forEach((c, i) => {
				c.order_no = i + 1;
			});
			this.sort_col = col;
			this.sort_dir = dir;
			this.order_dirty = true;
		},
		sortArrow(col) {
			if (this.sort_col !== col) return '';
			return this.sort_dir === 'asc' ? ' ▲' : ' ▼';
		},
		onDragStart(index, event) {
			if (!this.reorderEnabled) return;
			this.drag_from = index;
			if (event && event.dataTransfer) {
				event.dataTransfer.effectAllowed = 'move';
				event.dataTransfer.setData('text/plain', String(index));
			}
		},
		onDragEnter(index) {
			if (this.drag_from == null) return;
			this.drag_over = index;
		},
		onDragEnd() {
			this.drag_from = null;
			this.drag_over = null;
		},
		onDrop(to_index) {
			const from = this.drag_from;
			this.drag_over = null;
			this.drag_from = null;
			if (from == null || from === to_index) return;

			const moved = this.codes.splice(from, 1)[0];
			this.codes.splice(to_index, 0, moved);
			this.codes.forEach((c, i) => {
				c.order_no = i + 1;
			});
			this.sort_col = null;
			this.sort_dir = null;
			this.order_dirty = true;
		},
		async saveOrder() {
			if (!this.reorderEnabled || !this.order_dirty || this.codes.length == 0) return;

			const orders = this.codes.map((c, i) => ({ code: c.code, order_no: i + 1 }));
			const { data } = await apiUpdateOrderList({
				code_type: this.code_type,
				orders: orders,
			});
			if (data.result) {
				this.order_dirty = false;
				this.$toast.success('Order saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		onFilterChange() {
			if (this.order_dirty && !confirm('You have unsaved order changes. Discard them?')) {
				this.code_type = this.applied_filter.code_type;
				this.active_yn = this.applied_filter.active_yn;
				this.include_deleted = this.applied_filter.include_deleted;
				return;
			}
			this.selectCodes();
		},
		reset() {
			this.filterKeyword = '';
		},
		async clear() {
			if (confirm('Are you sure to delete the picture?')) {
				var picture = {
					code_type: this.code.code_type,
					code: this.code.code,
				};
				var response = await apiDeletePicture(picture);
				if (response.data.result) {
					this.$toast.success('File deleted successfully. Please save...');
					this.code.image_file_name = null;
					this.selectedCode.image_file_name = null;
				}
			}
		},
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				//this.$toast.success('File uploaded successfully');
				//console.log(newFilename);
				var picture = {
					code_type: this.code.code_type,
					code: this.code.code,
					image_file_name: newFilename,
				};
				response = await apiInsertPicture(picture);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully. Please save...');
					this.code.image_file_name = newFilename;
					this.selectedCode.image_file_name = newFilename;
					this.$refs.uploadFile.value = null;
				}
			}
		},
		getImageUrl(it) {
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + it.image_file_name;
			return url;
		},
		async selectCodes() {
			//this.code = {};
			//console.log(this.code_type);
			var param = {
				code_type: this.code_type,
				active_yn: this.active_yn,
			};
			if (this.include_deleted) param.include_deleted = true;

			const { data } = await apiSelectCodeList(param);

			//console.log(data);
			this.codes = data.codeList;
			if (this.codes.length > 0) this.selectRow(this.codes[0]);
			else this.code = {};

			this.order_dirty = false;
			this.sort_col = null;
			this.sort_dir = null;
			this.applied_filter = { code_type: this.code_type, active_yn: this.active_yn, include_deleted: this.include_deleted };
			this.filterKeyword = null;
			//else this.selectedCode = null;
		},
		add() {
			this.mode = 'add';
			this.code = {};
			this.code.code_type = this.code_type;
			this.code.active_yn = 'Y';
			// #3252 : 입력을 숨긴 경우 실제 저장 경로가 insertCode 의 #{order_no} 직접 바인딩이라
			// 신규 등록은 0 을 명시해 null 저장을 막는다. 입력이 보이는 화면(WL 등)은 종전 그대로다.
			if (this.hideOrderNo) this.code.order_no = 0;
			// var new_code = {
			// 	code_type: this.code_type,
			// 	active_yn: 'Y',
			// };
			//this.codes.push(new_code);

			this.selectedCode = {};
			this.$refs.code.focus();

			// this.selectedCode.name = null;
			//this.selectedCode.code_type = this.code_type;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckCodeExists(this.code);
			return data.result;
		},
		// checkDup() {
		// 	for (var i = 0; i < this.codes.length; i++) {
		// 		//if (this.codes[i].code == this.code || this.codes[i].order_no == this.order_no) return true;
		// 		if (this.codes[i].code == this.code) return true;
		// 	}
		// 	return false;
		// },
		async submit() {
			if (!this.isValid) return;

			if (!this.code.code) {
				this.$toast.error('Empty Code');
				return;
			}

			if (!this.code.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (this.code.code_type == 'RPT' && this.code.code == 'CREDIT') {
				this.$toast.error('"CREDIT" is a reserved code.');
				return;
			}

			// if (!this.code.order_no) {
			// 	this.$toast.error('Empty Order No');
			// 	return;
			// }

			//console.log(this.code);
			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Code');
					return;
				}
				response = await apiInsertCode(this.code);
			} else {
				response = await apiUpdateCode(this.code);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.codes.push(this.code);
				}
				// this.setSelectedCode();
				Object.assign(this.selectedCode, this.code);
				//console.log(this.backUri);
				//this.$router.push(this.backUri);
				//this.selectCodes();
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
		},
		//setSelectedCode() {
		// this.selectedCode.code_type = this.code.code_type;
		// this.selectedCode.code = this.code.code;
		// this.selectedCode.name = this.code.name;
		// this.selectedCode.description = this.code.description;
		// this.selectedCode.order_no = this.code.order_no;
		// this.selectedCode.active_yn = this.code.active_yn;
		//},
		async del() {
			if (!this.isDeletable) return;

			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteCode(this.code);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.selectCodes();
				} else {
					this.$toast.error('Failed');
				}
			}
			//console.log('delete');
		},
		selectRow(code) {
			this.mode = 'detail';
			this.selectedCode = code;

			this.code = _.cloneDeep(code);
			//console.log(code);
		},

		updateAllWhColorCode() {
			apiAllItemClassesWHColorCode()
				.then(response => {
					console.log(response.data);
					this.$toast.success('Updated successfully');
				})
				.catch(error => {
					console.log(error);
					this.$toast.error('Failed');
				});
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.order_dirty && !confirm('You have unsaved order changes. Leave anyway?')) {
			next(false);
		} else {
			next();
		}
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_code');
		this.$store.commit('setSubTitle', 'Basic Information -> Code');

		if (this.filteredCodeTypes.length > 0) {
			this.code_type = this.filteredCodeTypes[0].value;
			this.selectCodes();
		}
	},
	mounted() {
		inputSelectOnClick();

		$('.table-wrapper').on('scroll', function() {
			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				//var $rows = $('#item_list tbody tr');
				var $rows = $('.list_table tbody tr');
				var lastActiveIndex = $rows.filter('.active:last').index();
				$rows.filter(':lt(' + (lastActiveIndex + 25) + ')').addClass('active');
			}
		});

		window.addEventListener('keypress', event => {
			//console.log(event.target.tagName.toUpperCase());
			if (event.target.tagName.toUpperCase() == 'BODY') {
				//console.log('target body', event.key);
				if (event.which !== 0) {
					//console.log("Character was typed. It was: " + String.fromCharCode(e.which));
					var search_character = String.fromCharCode(event.which);

					// #3252 : beautyplus 는 맨 앞에 No. 셀이 생겨 종전 첫 셀(#3126 드래그/빈 셀)이
					// 한 칸 밀린다. 보정하지 않으면 숫자 키가 행 번호에 매칭되는 새 동작이 생긴다.
					// (이 탐색이 Code 셀을 읽던 기능은 #3126 이후 전 회사에서 이미 동작하지 않으며,
					//  되살리면 non-beautyplus 동작이 바뀌므로 여기서는 종전 무반응만 유지한다.)
					var first_cell_index = this.isBeautyplus ? 1 : 0;
					$('#item_list > tbody > tr').each(function() {
						var textval = $(this)
							.find('td')
							.eq(first_cell_index)
							.text();
						if (textval.substring(0, 1).toUpperCase() == search_character.toUpperCase()) {
							$(this)
								.get(0)
								.scrollIntoView();
							return false;
						}
					});
				}
			}
			//console.log(e.target);
			// if (e.key == 'Escape') {
			// 	this.showModal = !this.showModal;
			// }
		});
	},
};
</script>

<style>
.sortable {
	cursor: pointer;
}
.drag-handle {
	cursor: move;
	text-align: center;
	color: #bbb;
}
.drag-handle:hover {
	color: #409eff;
}
.drag-over td {
	box-shadow: inset 0 2px 0 0 #409eff;
}
.reorder-hint {
	color: #999;
	margin-right: 15px;
}
.reorder-help {
	color: #909399;
	margin-right: 15px;
}
.reorder-dirty {
	color: #e6a23c;
	margin-right: 15px;
}
</style>
